import React from 'react';
import Moment from 'moment';
import {connect} from 'react-redux';
import {PDFExport} from "@progress/kendo-react-pdf";
import inrInWords from '../../../../../../../Utils/INRToWords';
import TigerLogo from "../../../../fContracts/ContractDetails/Details/tigerLogo.png";

class TigerAnalytics extends React.Component {
    render() {
        let list = this.props.data;
        let { vendor, orderId, details, billingTo, procured } = this.props.data;
        return (
          <div>
            <div
              style={{
                textAlign: "right",
              }}
            >
              <p
                style={{
                  fontWeight: 600,
                  color: "var(--primary-color)",
                  cursor: "pointer",
                }}
                onClick={() => {
                  this.pdf.save();
                }}
              >
                Download Now
              </p>
            </div>
            <PDFExport
              title="Order Document"
              padding="40"
              fileName={`Order-${list.orderId}.pdf`}
              ref={(r) => (this.pdf = r)}
            >
            <div>
            <table style={{"max-width": "1000px", "width":"1000px","border": "#808080 solid 2px", "marginTop":"20px"}}>
              <tr>
                <td colspan="5">
                  <img src={TigerLogo} alt="" style={{"height":"200px","width":"200px","marginLeft":"-200px"}}/>
                </td>
                <td colspan="5">
                  <div style={{"width":"300px","font-size": "xx-large","margin-top": "10px","font-weight":"400"}}>PURCHASE ORDER</div>
                </td>
              </tr>
              <tr style={{"border-top": "#808080 2px solid", "height": "60px"}}>
                <td colspan="5" style={{"border": "#808080 1px solid","border-right": "2px solid #808080"}} >
                    <div style={{"display":"flex","flex-direction":"column"}}>
                        <div style={{"display": "flex","justify-content":"space-between", "font-size": "12px", "width":"400px"}}>
                            <p>PO No </p>
                            <p style={{"font-weight": "bold"}}>: {orderId} </p>
                        </div>
                        <div style={{"display": "flex","justify-content":"space-between", "font-size": "12px", "width":"400px"}}>
                            <p>PO Date </p>
                            <p style={{"font-weight": "bold"}}>: {Moment(details.createdAt).format("DD-MMM-YYYY")} </p>
                        </div>
                    </div>
                </td>
                <td colspan="5" style={{"border": "#808080 1px solid","border-left": "2px solid #808080"}}>
                    <div style={{"display": "flex","justify-content":"space-between", "font-size": "12px", "width":"400px"}}>
                        <p>Location </p>
                        <p style={{"font-weight": "bold"}}>:{details.officeName}  </p>
                    </div>
                </td>
              </tr>
              <tr style={{"background-color": "#D3D3D3"}}>
                  <td colspan="5" style={{"border": "#808080 1px solid", "border-right": "2px solid #808080"}} >
                      <div style={{"font-size": "12px"}}>Procured From</div>
                  </td>
                  <td colspan="5" style={{"border": "#808080 1px solid", "border-left": "2px solid #808080"}}>
                      <div></div>
                  </td>
              </tr>
              <tr style={{"border-top": "#808080 2px solid", "font-size": "12px"}}>
                  <td colspan="5" style={{"border": "#808080 1px solid", "border-right": "2px solid #808080"}} >
                      <div style={{"display":"flex","align-items":"start","flex-direction":"column"}}>
                          <p style={{"font-weight":"bold","text-align":"left"}}>{vendor.name}</p>
                          <p style={{"text-align":"left"}}>{vendor.address.address}</p>
                          <br/>
                          <p style={{"text-align":"left"}}>GSTIN {vendor.gstin}</p>
                          <p style={{"text-align":"left"}}>PAN: {vendor.pan}</p>
                      </div>
                  </td>
                  <td colspan="5" style={{"border": "#808080 1px solid", "border-right": "2px solid #808080"}}>
                      <div style={{"align-items":"left"}}>
                          <p style={{"font-weight":"bold", "text-align":"left"}}>TIGER ANALYTICS INDIA CONSULTING PRIVATE LIMITED</p>
                          <p style={{"text-align":"left"}}>{details.officeAddress}</p>
                          <br/>
                          <p style={{"text-align":"left"}}>GSTIN {billingTo.gstin}</p>
                          <p style={{"text-align":"left"}}>PAN: AAICT8986D</p>
                      </div>
                  </td>
              </tr>
              <tr style={{"background-color": "#D3D3D3"}}>
                <td colspan="1" rowspan="2"
                    style={{"width": "40px","font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                    <p style={{"margin": "5px 0px"}}>#</p>
                </td>
                <td colspan="2" rowspan="2" style={{"width": "500px", "font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                    <p style={{"margin": "5px 0px"}}>Item & Description</p>
                </td>
                <td colspan="1" rowspan="2"
                    style={{"font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                    <p style={{"margin": "5px 0px"}}>HSN/SAC</p>
                </td>
                <td colspan="2" rowspan="2"
                    style={{"font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                    <p style={{"margin": "5px 0px"}}>Qty</p>
                </td>
                <td colspan="1" rowspan="2" style={{"font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                    <p style={{"margin": "5px 0px"}}>Rate</p>
                </td>
                <td colspan="2" rowspan="1" style={{"width": "150px", "font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                    <p style={{"margin": "5px 0px"}}>{`${vendor.gstin===billingTo.gstin?"CGST/SGST":"IGST"}`}</p>
                </td>
                <td colspan="1" rowspan="2" style={{"font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                    <p style={{"margin": "5px 0px"}}>Amount</p>
                </td>
              </tr>
              <tr>
                  <td colspan="1" rowspan="1" style={{"width": "25px", "font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                      <p style={{"margin": "5px 0px"}}>%</p>
                  </td>
                  <td colspan="1" rowspan="1" style={{"width": "25px", "font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                      <p style={{"margin": "5px 0px"}}>Amt</p>
                  </td>
              </tr>
              {procured.map((item, index) => {
                  return (
                    <tr style={{"border": "solid 01px #000"}}>
                        <td colspan="1" style={{"border": "solid 1px #000", "padding": "5px", "text-align": "center", "font-size": "12px"}}>{index+1}</td>
                        <td colspan="2"
                            style={{"border": "solid 1px #000", "padding": "5px", "text-align": "center", "font-size": "12px"}}>
                             {item.notes} <br/>
                        </td>
                        <td colspan="1" style={{"border": "solid 1px #000", "padding": "5px", "text-align": "center", "font-size": "12px"}}> {item.hsn}</td>
                        <td colspan="2" style={{"border": "solid 1px #000", "padding": "5px", "text-align": "center", "font-size": "12px"}}> {item.qtty} </td>
                        <td colspan="1" style={{"border": "solid 1px #000", "padding": "5px", "text-align": "center", "font-size": "12px"}}> {item.price} </td>
                        <td colspan="1" style={{"border": "solid 1px #000", "padding": "5px", "text-align": "center", "font-size": "12px"}}>
                          {item.taxSlab}
                        </td>
                        <td colspan="1" style={{"border": "solid 1px #000", "padding": "5px", "text-align": "center", "font-size": "12px"}}>
                             {item.tax}
                        </td>
                        <td colspan="1" style={{"border": "solid 1px #000", "padding": "5px", "text-align": "center", "font-size": "12px"}}>
                          {item.base}
                        </td>
                    </tr>
                  );
                })}
                <tr style={{"border-top": "#808080 2px solid", "font-size": "12px"}}>
                    <td colspan="5" style={{"border": "#808080 1px solid", "border-right": "2px solid #808080"}} >
                        <div style={{"text-align":"left"}}>
                            <p>Total In Words</p>
                            <p style={{"font-weight": "bold"}}>{inrInWords(
                              procured.reduce((total, item) => total + item.amount, 0)
                          )}</p>
                        </div>
                    </td>
                    <td colspan="5" style={{"border": "#808080 1px solid", "border-left": "2px solid #808080"}}>
                        <div style={{"margin-left": "100px"}}>
                            <div style={{"display": "flex", "justify-content": "space-between"}}>
                                <p>Sub Total</p>
                                <p>request.subTotal</p>
                            </div>
                            {/* {% for item in request.items %}
                                        <div style="display: flex; justify-content: space-between;">
                                            <p>{{item.gstType}} ({{item.gstPercent}})</p>
                                            <p>{{item.totalGst}}</p>
                                        </div>
                                    {% endfor %} */}
                            <div style={{"display": "flex", "justify-content": "space-between"}}>
                                <p>Rounding</p>
                                <p>request.rounding</p>
                            </div>
                            <div style={{"display": "flex", "justify-content": "space-between"}}>
                                <p>Total</p>
                                <p>request.total</p>
                            </div>
                        </div>
                    </td>
                </tr>
                <tr style={{"border-top": "#808080 2px solid", "height": "150px", "font-size": "12px"}}>
                    <td colspan="5" style={{"border": "#808080 1px solid", "border-right": "2px solid #808080"}} >
                        <div style={{"margin-top": "-50px","text-align":"left"}}>
                            <p>MSME Compliances:</p>
                            <p style={{"text-align":"left"}}>
                                1. Every year on or before 31st March, MSME declaration to be furnished to consider your entity as MSME
                                <br/>
                                2. Invoice should be submitted within 10 days from data of invoice otherwise the said invoice will be cancelled</p>
                        </div>
                    </td>
                    <td colspan="5" style={{"border": "#808080 1px solid", "border-left": "2px solid #808080"}}>
                        <div style={{"display": "flex", "justify-content": "center", "margin-top": "120px"}}>Authorised Signature</div>
                    </td>
                </tr>
                <tr style={{"border-top": "#808080 2px solid", "font-size": "12px"}}>
                    <td colspan="10">
                        <p style={{"text-align":"left", "margin-top":"20px"}}>PO Terms and Condition:</p>
                        {/* <div style={{"margin-left": "20px", "width": "850px"}}>
                            {% for term in request.termsAndConditions %}
                                <p>{{term.termNo}}. {{term.content}}</p>
                            {% endfor %}
                        </div> */}
                    </td>
                </tr>
                <tr style={{"font-size": "12px"}}>
                    <td colspan="10">
                        <div style={{"display": "flex", "justify-content": "center", "margin-top": "50px", "margin-bottom": "20px"}}>Annexure -1</div>
                        <table style={{"max-width": "800px", "border": "#808080 solid 0px", "margin": "0 auto"}}>
                            <tr>
                                <td colspan="1"
                                    style={{"font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                                    <p style={{"margin": "5px 0px"}}>S.No</p>
                                </td>
                                <td colspan="2" style={{"font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                                    <p style={{"margin": "5px 0px"}}>Description</p>
                                </td>
                                <td colspan="1"
                                    style={{"font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                                    <p style={{"margin": "5px 0px"}}>Quantity</p>
                                </td>
                                <td colspan="2"
                                    style={{"font-weight": "700", "border": "1px solid #000", "color":"#303c42", "font-size":"12px", "padding-left": "4px", "text-align": "center"}}>
                                    <p style={{"margin": "5px 0px"}}>Rate</p>
                                </td>
                            </tr>
                            {procured.map((item, index) => {
                                return (
                                  <tr style={{"border": "solid 01px #000"}}>
                                    <td colspan="1" style={{"border": "solid 1px #000" ,"padding": "5px", "text-align": "center" ,"font-size": "12px"}}>{index+1}</td>
                                    <td colspan="2"
                                        style={{"border": "solid 1px #000" ,"padding": "5px", "text-align": "center" ,"font-size": "12px"}}>
                                        {item.notes}<br/>
                                    </td>
                                    <td colspan="1" style={{"border": "solid 1px #000" ,"padding": "5px", "text-align": "center" ,"font-size": "12px"}}>{item.qtty}</td>
                                    <td colspan="1" style={{"border": "solid 1px #000" ,"padding": "5px", "text-align": "center" ,"font-size": "12px"}}>{ item.price }</td>
                                </tr>
                                );
                              })}
                        </table>
                    </td>
                </tr>
              </table>
              <footer>
                <div style={{"font-weight": "bold", "font-size": "13px", "text-align": "center", "color":"#ff8d00", "margin-top": "20px"}}>
                    <p>TIGER ANALYTICS INDIA CONSULTING PVT LTD</p>
                    <p>(CIN: U74999TN2021FTC146673)</p>
                    <p>RMZ Millenia Business Park-2,Campus 5(2nd Floor) No. 143, Kandanchavadi,</p>
                    <p>MGR Road, Perungudi, Chennai 600096. www.tigeranalytics.com</p>
                </div>
            </footer>
            </div>
            
            </PDFExport>
          </div>
        );
    }
}

export default connect(state => {
    return {
        config: state.auth.config
    }
}, null)(TigerAnalytics);
